// MessageEditor.jsx

import React from 'react';

// CSS
import './MessageEditor.css';

/**
 * MessageEditor
 *
 * @returns {ReactNode} The rendered component.
 */
const MessageEditor = React.memo(({
  draftText,
  onChangeDraft,
  onSave,
  onCancel,
  theme,
}) => {

  // ----- RENDER ----- //

  return (
  <div className="message-edit-wrap">

    {/* MESSAGE EDIT INPUT */}
    <textarea
      className="message-edit-input"
      value={draftText}
      rows={3}
      onChange={(event) => onChangeDraft(event.target.value)}
    />

    {/* MESSAGE EDIT ACTIONS */}
    <div className="message-edit-actions">

      {/* MESSAGE EDIT ACTION */}
      <button
        className="message-edit-action"
        style={{
          color: theme.highlightForeground || '#FFFFFF',
        }}
        type="button"
        onClick={onSave}
      >
        Save
      </button>

      {/* MESSAGE EDIT ACTION */}
      <button
        className="message-edit-action is-secondary"
        type="button"
        onClick={onCancel}
      >
        Cancel
      </button>
    </div>
  </div>
);
});

// Dev Tools
MessageEditor.displayName = 'MessageEditor';

export default MessageEditor;
